/**
 * Reads a stored file's bytes from its storage link (a GCS signed or public URL the load or invoice holds). The one call in this feature
 * that is not an API client: the link is not a Numeo endpoint, it carries its own signature, and the app's axios instances would add
 * the session's `Authorization` header and base URL, which a signed storage URL refuses. So it is a plain `fetch`, kept here so
 * components and hooks never call one.
 */
export async function fetchStoredFileBlob(url: string, signal?: AbortSignal): Promise<Blob> {
    const response = await fetch(url, { signal })
    if (!response.ok) throw new Error(`The file answered ${response.status}`)
    return response.blob()
}
